import React from "react";
import { Link, StaticQuery, graphql } from "gatsby";
import Prose from "./utility/prose";

const Footer = () => (
  <StaticQuery
    query={graphql`
    query {
        site {
            siteMetadata {
                fullname
            }
        }
    }
    `}
    render={data => (
      <footer className="text-center bg-zinc-200 dark:bg-zinc-800 px-4 py-8">
        <Prose>
          <p><strong>Main Office Hours</strong></p>
          <p>Monday and Tuesday: 8 a.m. - 1 p.m.<br />
            Wednesday and Thursday: 11 a.m. - 4 p.m.<br />
            Friday (contact customer service at 866-467-1599 for assistance)</p>

          <p>1000 Old Mill Road, Cedar Park, TX 78613<br />
            <a className="text-inherit" href="tel:+18664671599">866-467-1599</a></p>
          <p>&copy; {new Date().getFullYear()} {data.site.siteMetadata.fullname}<br />
            <Link className="text-inherit" to="/legal-notices-and-disclaimers">Legal Notices & Disclaimers</Link>
          </p>
          <small>Website provided by <a className="text-inherit" href="https://www.touchstonedistrictservices.com/" target="_blank" rel="noopener noreferrer">Touchstone</a></small>
        </Prose>
      </footer>
    )} />
)

export default Footer
